var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"AppFooter"}},[_c('div',{staticClass:"greenBar"}),_c('img',{staticClass:"logo img-responsive",attrs:{"alt":"ARM logo","src":require("../assets/ARM_Logo_White.svg")}}),_c('div',{staticClass:"version"},[_vm._v("Version "+_vm._s(this.$store.state.appVersion))])])
}
var staticRenderFns = []

export { render, staticRenderFns }